import { render } from "./InvestmentRussiaCard.vue?vue&type=template&id=34333b16&scoped=true"
import script from "./InvestmentRussiaCard.vue?vue&type=script&lang=js"
export * from "./InvestmentRussiaCard.vue?vue&type=script&lang=js"

import "./InvestmentRussiaCard.vue?vue&type=style&index=0&id=34333b16&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34333b16"]])

export default __exports__